import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { ApiAuthHttpClient } from '../http/ApiAuthHttpClient';
import { environment as env } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Store } from '../store';
import { Notes } from '../models/notes';

@Injectable({
    providedIn: 'root'
})
export class NotesService
{
    constructor(
        private http: ApiAuthHttpClient,
        private store: Store,
    )
    {
    }

    public getNotesFor(type: string, recordId: string = 'all'): Observable<any>
    {  // https://api.ysdev.co.uk/notes/:type/:recordId
        return this.http
            .get(env.apiPath + `notes/${type}/${recordId}`)
            .pipe(map((result: any) => result.data));
    }

    public getNotesEndsWithRecordId(type: string, recordId): Observable<any>
    {  // https://api.ysdev.co.uk/notes/:type/ends/:recordId
        return this.http
            .get(env.apiPath + `notes/${type}/ends/${recordId}`)
            .pipe(
                map((result: any) => result.data.map(note => {
                    note.files = JSON.parse(note.files);
                    return note;
                }))
            );
    }

    public addNote(note: Notes): Observable<any>
    {
        return this.http
            .post(env.apiPath + `notes`, {
                ...note,
                createdBy: this.store.selectForLocal("user").id
            })
            .pipe(map((result: any) => result.data));
    }
}
